module.exports = __webpack_public_path__ + "img/forward_5.52b711b1.svg";